import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import router from '../router'
import store from '@/store'
import { ERROR_TYPES } from '@/store/modules/error'

const defaultOptions = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'content-type': 'application/json; charset=utf-8',
    Accept: 'application/json'
  },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
}

/*
  This handler is set up as an interceptor below, so it will handle any http errors.
  To disable this global error handler and handle the error at the component level,
  just specify handleError: false in your request config
  ex. axios.get('/user/1', {handleError: false})
 */
function errorResponseHandler (error) {
  if (Object.prototype.hasOwnProperty.call(error.config, 'handleError') && error.config.handleError === false) {
    return Promise.reject(error)
  }
  handleError(error)
}

export const handleError = (error) => {
  if (error.response) {
    console.error(JSON.stringify(error))
    if (error.response.data && error.response.data.isUserFriendly) {
      error.message = error.response.data.message
    } else {
      error.message = `${error.message} | url: ${error.config.url} | method: ${error.config.method}`
    }
    store.dispatch(ERROR_TYPES.actions.setError, error)
    if (router.currentRoute.path !== '/error') {
      router.push('/error')
    }
  }
}

export const http = () => {
  // Create instance
  const instance = axios.create(defaultOptions)

  instance.interceptors.response.use(
    response => {
      const res = response ? response.data : response // Map response to data by default
      res.status = response.status
      return res
    },
    errorResponseHandler // Set a global error handler for each response
  )

  Vue.prototype.$http = instance

  return instance
}

export default http
